import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

export const isPaidKwSearchAvailable = (): boolean => {
    return isAvailable(swSettings?.components?.PaidKwSearchTab);
};

export const isPaidSearchPagesAvailable = (): boolean => {
    return isAvailable(swSettings?.components?.PaidSearchPages);
};
